import * as React from 'react';
import {
  SearchBox
} from '../../../../index';

export class SearchBoxFullSizeExample extends React.Component<any, any> {
  public render() {
    return (
      <SearchBox />
    );
  }

}
